import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HubHomePageComponent } from './pages/hub-home-page/hub-home-page.component';
import { LoginComponent } from './pages/login/login.component';
const routes: Routes = [
  {
    path: '', component: LoginComponent,
  },
  {
    path: 'home', component: HubHomePageComponent,
  },
  {
    path: 'login', component: LoginComponent
  },
  {
    path: 'logout', component: LoginComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
